import { PollsProps } from './types';

export const Polls = ({ children }: PollsProps) => <>{children}</>;
